import { render } from "./JFirstDetail.vue?vue&type=template&id=3a4ad0ee&scoped=true"
import script from "./JFirstDetail.vue?vue&type=script&lang=js"
export * from "./JFirstDetail.vue?vue&type=script&lang=js"

import "./JFirstDetail.vue?vue&type=style&index=0&id=3a4ad0ee&lang=scss&scoped=true"
import "./JFirstDetail.vue?vue&type=style&index=1&id=3a4ad0ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4ad0ee"]])

export default __exports__